/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { PageHeader } from '@/components/PageHeader';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Button } from '@/primitives/Button';
import { Link } from '@/primitives/Link';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import './InstallerTokensHeader.css';

type InstallerTokensHeaderProps = {
  onGenerateClick: () => void;
};

export function InstallerTokensHeader({ onGenerateClick }: InstallerTokensHeaderProps) {
  const { t } = useMimicTranslation('installerTokens');
  const tenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  return (
    <div className="installer-tokens-header">
      <PageHeader title={t('listTitle')} text={t('description')} level={2} />
      <div className="installer-tokens-header-actions">
        <Link
          to={`/tenants/${tenantID}/installer-tokens/revoked`}
          dataTestId="view-revoked-tokens-link"
          style={{ color: '#605F5E' }}
        >
          {t('viewRevokedTokens')}
        </Link>
        <Button type="primary" onClick={onGenerateClick} dataTestId="generate-token-button">
          {t('generateToken')}
        </Button>
      </div>
    </div>
  );
}
